<template lang="html">

  <section class="popup-rgpd row-center" v-if="!!textoRGPD">
    
    <div class="contenedor-popup-rgpd" :style="ownstyle.popup">

      <div class="contenedor-texto" >

        <!-- RGPD CUANDO TIENE UN CHECKBOX -->
        <div v-if="textoRGPD.text.includes('[[[CHECKBOX]]]')">
          <div v-html="textoRGPD.text.split('[[[CHECKBOX]]]')[0]"></div>
          <div v-html="textoRGPD.text.split('[[[CHECKBOX]]]')[1]"></div>
        </div>

        <!-- RGPD CUANDO NO TIENE CHECKBOX -->
        <div v-else v-html="textoRGPD.text"></div>

        <div class="bottom-container">

          <h2>{{$t('login.popup_rgpd.titulo')}}</h2>

          <div class="enlace">
            {{$t('login.popup_rgpd.detalle')}}
           <router-link target="_blank" :to="$t('enlaces.proteccion_datos')" v-if="!!!textoRGPD.link">{{$t('login.popup_rgpd.enlace')}}</router-link>
           <a v-if="!!textoRGPD.link" :href="textoRGPD.link" target="_blank">{{$t('login.popup_rgpd.enlace')}}</a>
         </div>

          <!-- CHECKBOX DE RGPD (CUANDO TIENE) -->
          <div v-if="textoRGPD.text.includes('[[[CHECKBOX]]]')">
            <input type="checkbox" id="chkAceptarRgdp" v-model="aceptado" style="appearance: auto !important;"> He leído y acepto la información sobre el tratamiento de datos personales
          </div>

         <div class="contenedor-boton row-end">
          <a class="btn -xs -solid-primary " @click="sendguardarRGPD" :loading="loading">
            {{$t('login.popup_rgpd.boton')}}
          </a>          
        </div>

      </div>

    </div>

  </div>

</section>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex'

  import router from '@/router';

  export default  {
    name: 'popup-rgpd',
    props : ['how'],
    data(){
      return{
        loading : false,
        aceptado: false
      }
    },
    computed :{
      ...mapGetters({
        textoRGPD : 'getTextoRGPD',
        colors : 'basicColors',
        style : 'getStyles',
        isEmpresa : 'isEmpresa'
      }),
      ownstyle : function(){
        return {
          popup :{
            background: this.colors.white
          }
        }
      }
    },
    methods :{
      ...mapActions(['guardarRGPD','guardarRGPDEncuesta','setError']),
      sendguardarRGPD : function(){
        if (this.textoRGPD.text.includes('[[[CHECKBOX]]]') && !this.aceptado){
          this.setError(542);
          return;
        }
        if(this.$route.name == 'ficha_encuestas' | this.$route.name == 'acceso_encuesta'){
          this.loading = true;
          this.guardarRGPDEncuesta(this.$route.params.id).then(r => {
            if(this.$route.name == 'acceso_encuesta'){
              router.push('/encuestas/'+this.$route.params.id);
            }
            this.loading = false;
          })
        }else{
          this.loading = true;
          this.guardarRGPD((this.how == 'empresas')).then(r => {
            router.push('/');
            this.loading = false;
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .popup-rgpd {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    z-index: 20;
    padding: 20px;
  }


  
  
  .contenedor-texto{
    overflow: scroll;
    overflow-x: hidden;
    max-height: 100%;
    padding: 0 10px;
    width: 100%;

/*    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ffffff;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #ffffff;
    }
    &::-webkit-scrollbar-thumb:active {
      background: #000000;
    }
    &::-webkit-scrollbar-track {
      background: #666666;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    &::-webkit-scrollbar-track:hover {
      background: #666666;
    }
    &::-webkit-scrollbar-track:active {
      background: #333333;
    }
    &::-webkit-scrollbar-corner {
      background: transparent;
      }*/
    }

    .bottom-container{
      
      font-weight: 300;
      width: 100%;

      .enlace{
        margin-bottom: 15px;
        width: 100%;
        display: inline-block;
      }

      .enlace a{
        text-decoration: underline;
      }
    }

  </style>



// WEBPACK FOOTER //
// src/components/views/login/popup-rgpd.vue